import { showToast } from '../../application/utils/toast.util';
import {client, clientAlderaan} from '../../core/stores';
import {MUTATION_ACCOUNT_PLAN} from '../../core/graphql/types';

declare const M: any;

interface PricingRule {
  id?: string | number;
  metricType: string;
  metricThreshold: number;
  basePrice: number;
  description?: string;
  order: number;
}

interface AccountPlanData {
  name: string;
  billingTriggerType: string;
  accountPlanPricingRules?: PricingRule[];
  [key: string]: any;
}

export function MutationAccountPlan(
  plan: AccountPlanData,
  scope: string,
  setSubmitting: (value: boolean) => void,
  setErrors: (errors: any) => void,
): Promise<{status: string; plan: any}> {
  return new Promise((resolve, reject) => {
    const {name, billingTriggerType} = plan;
    if (!name || !billingTriggerType) {
      const error: any = {};
      if (!name)
        error.name = 'Para salvar um plano, você precisa preencher o nome';
      if (!billingTriggerType)
        error.billingTriggerType =
          'Para salvar um plano, você precisa escolher o tipo de cobrança';

      showToast({
        html: 'Para salvar um plano, você precisa preencher os campos obrigatórios',
        displayLength: 5000,
      });
      setErrors(error);
      reject(error);
      setSubmitting(false);
      return;
    }
    const mutationClient =
      scope === 'alderaan' ? client('alderaan') : client('account');

    // Debug: verificar o que chega no plan
    console.log('📥 Plan recebido:', {
      accountPlanPricingRules: plan.accountPlanPricingRules,
      firstRule: plan.accountPlanPricingRules?.[0],
    });

    // Preparar variáveis para envio
    const variables: AccountPlanData = {...plan};

    // Converter regras de preço para o formato correto ANTES da conversão geral
    if (
      variables.accountPlanPricingRules &&
      Array.isArray(variables.accountPlanPricingRules)
    ) {
      console.log(
        '🔍 ANTES da conversão:',
        variables.accountPlanPricingRules[0],
      );

      variables.accountPlanPricingRules = variables.accountPlanPricingRules.map(
        (rule: PricingRule) => {
          // Garantir que sejam números, não strings
          const metricThreshold =
            typeof rule.metricThreshold === 'string'
              ? parseFloat(rule.metricThreshold)
              : rule.metricThreshold;

          const basePrice =
            typeof rule.basePrice === 'string'
              ? parseFloat(rule.basePrice)
              : rule.basePrice;

          const order =
            typeof rule.order === 'string' ? parseInt(rule.order) : rule.order;

          const converted = {
            id: rule.id || undefined,
            metricType: rule.metricType,
            metricThreshold: metricThreshold,
            basePrice: basePrice,
            description: rule.description || '',
            order: order,
          };

          console.log('🔍 DEPOIS da conversão:', converted);
          console.log('  - basePrice type:', typeof converted.basePrice);
          console.log(
            '  - metricThreshold type:',
            typeof converted.metricThreshold,
          );

          return converted;
        },
      ) as any;
    }

    // Converter números em strings (exceto accountPlanPricingRules que já foi processado)
    Object.keys(variables).forEach((k) => {
      if (k !== 'accountPlanPricingRules' && typeof variables[k] === 'number') {
        variables[k] = '' + variables[k];
      }
    });

    // Debug: verificar tipos das pricing rules
    if (
      variables.accountPlanPricingRules &&
      variables.accountPlanPricingRules.length > 0
    ) {
      console.log(
        '🔍 Pricing Rules ANTES do envio:',
        variables.accountPlanPricingRules.map((r) => ({
          ...r,
          basePriceType: typeof r.basePrice,
          thresholdType: typeof r.metricThreshold,
        })),
      );
    }

    console.log('📤 Variables COMPLETAS:', JSON.stringify(variables, null, 2));

    // Log IMEDIATAMENTE antes do mutate
    console.log('⚡ EXATAMENTE antes do Apollo mutate:');
    console.log(
      'Type of basePrice:',
      typeof variables.accountPlanPricingRules?.[0]?.basePrice,
    );
    console.log(
      'Value of basePrice:',
      variables.accountPlanPricingRules?.[0]?.basePrice,
    );
    console.log('Objeto completo:', variables.accountPlanPricingRules?.[0]);

    mutationClient
      .mutate({
        mutation: MUTATION_ACCOUNT_PLAN,
        variables: variables,
      })
      .then((response: any) => {
        const {data} = response;
        const {createOrUpdateAccountPlan} = data || {};
        showToast({html: 'Plano atualizado com sucesso!'});
        setSubmitting(false);
        const {accountPlan: planUpdated} = createOrUpdateAccountPlan;
        resolve({status: 'success', plan: planUpdated});
      })
      .catch((err: any) => {
        console.log('ERROR ==> ', err);
        setSubmitting(false);
        const errorMessage = err.graphQLErrors
          .map((error: any) => error.message)
          .join(',');
        showToast({html: 'Houve um erro na sua solicitação.'});
        showToast({html: errorMessage});
        reject({status: 'error', message: errorMessage});
      });
  });
}
